module.exports = __webpack_public_path__ + "img/dot.d055b5d7.svg";